import { StringHelper } from "helpers";
import * as _ from "lodash";

export function formatDataForDetailsMainPanel(
	data: { [key: string]: any },
	fields: string[],
	fieldNames: { [key: string]: string },
	showDefaultLinkNames?: boolean
) {
	const dataFormatted: any = {};

	fields.forEach((field) => {
		if (!fieldNames[field] || !data) return;

		dataFormatted[fieldNames[field]] = {};
		let linkCount = 0;
		if (
			data[field] &&
			(Array.isArray(data[field]) || typeof data[field] === "object")
		)
			Object.entries(data[field]).forEach((entry) => {
				const [key, value] = entry;

				let formattedValue = value;
				if (typeof value === "object")
					formattedValue = formatDataForDetailsMainPanel(
						{ ...value },
						Object.keys({ ...value }),
						fieldNames
					);
				if (formattedValue instanceof Object && _.isEmpty(formattedValue)) {
					formattedValue = "";
				}
				dataFormatted[fieldNames[field]][
					StringHelper.isValidHttpUrl(String(value)) && showDefaultLinkNames
						? // eslint-disable-next-line no-plusplus
						  `Link ${++linkCount}`
						: fieldNames[key]
				] = formattedValue;
			});
		else
			dataFormatted[fieldNames[field]][
				StringHelper.isValidHttpUrl(String(data[field]))
					? `Link 1`
					: fieldNames[field]
			] = data[field];
	});

	return dataFormatted;
}
